<template>
  <div>
    <v-card class="mx-auto pa-6 mt-6" max-width="500">
      <v-card-subtitle>Adresse courriel utilisée dans le Portail sécurisé</v-card-subtitle>
      <v-card-text>
        <v-text-field
          id="login"
          ref="login"
          label="Courriel"
          v-model="login"
          outlined
          dense
          :loading="updating"
          :disabled="updating"
        ></v-text-field>
      </v-card-text>

      <v-card-subtitle>Mot de passe utilisé dans le Portail sécurisé</v-card-subtitle>
      <v-card-text>
        <v-text-field
          id="password"
          ref="password"
          label="Mot de passe"
          type="password"
          v-model="password"
          outlined
          dense
          :loading="updating"
          :disabled="updating"
        ></v-text-field>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn x-large dark color="#3a3838" @click="submit">Se connecter</v-btn>
      </v-card-actions>

      
      <v-card-text v-if="authFailed"> 
        <p class="red--text">Identifiants incorrects.</p>
        <p>
          Vous devez utiliser votre compte du Portail sécurisé de l'Ordre des psychologues pour pouvoir vous connecter.<br />
          <a :href="urlPortail">Pour réinitialiser votre mot de passe, veuillez d'abord utiliser cette fonction dans le Portail sécurisé.</a>
        </p>
        <p>Si vous éprouvez des difficultés à vous connecter, veuillez communiquer avec le Service d'inscription aux membres à <a href="mailto:info@ordrepsy.qc.ca">info@ordrepsy.qc.ca</a> ou composez le 514 738-1881(Numéro sans frais : 1 800 363-2644).</p>
      </v-card-text> 
    </v-card>
  </div>
</template>

<script>

import { authenticate } from "@/plugins/services/auth"

export default {
  data() {
    return {
        login: "",
        password: "",
        authFailed: false,
        updating: false,
    }
  },
  created() {
  },
  mounted() {
  },
  
  computed: {
    urlPortail() {
      return process.env.VUE_APP_URL_PORTAIL
    }
  },

  methods: {
    async submit() {
        try {
          this.updating = true
          let result = await authenticate(this.login, this.password)
          if (result.status == 200 
              && result.data
              && result.data.success == true) {
            //console.log("Auth Ok")
            this.authFailed = false

            if (result.data.redirectUrl && result.data.redirectUrl != '')
            {
              //console.log(result.data.redirectUrl)
              window.location.href = result.data.redirectUrl
            }
          } else {
            this.authFailed = true
          }
        } catch (error) {
            this.authFailed = true
            //console.log(error)
        } finally {
          this.updating = false
        }
    }
  }
}
</script>

<style scoped>
</style>
